import React, { Component } from 'react';
import { isEmpty } from "lodash";

import { normalizeStr } from '../../../utils/generalFuncs';
import Dialog from '../../common/Dialog';
import InputText from '../../common/Form';

class FunctionForm extends Component {
    state = { 
        function_name: this.props.function ? this.props.function.function_name : "",
        errors:{
            function_name: "",
        }
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        this.setState({
            [name]: value
        })
    }
    validate = () => {
        let required = [
            "function_name",
            
        ]
        
        let noError = true
        let errors = {}
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
    
        this.setState({
            errors
        })
        return noError
    }
    
    nameExist = (name, id) => {
        const { FUNCTIONS } = this.props;
        let list = []
        list = Object.values(FUNCTIONS).filter(item =>  ( 
            (normalizeStr(item.function_name) === normalizeStr(name) ) && 
            (item.function_id !== id) 
        ) )
            
        console.log("Item exist",{list});
        return !isEmpty(list)
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = {}
            if (this.props.update) {
                data = Object.assign(data, this.props.function)
            }
            data.function_name = this.state.function_name.trim().toUpperCase()
    
            console.log('====================================');
            console.log({data});
            console.log('====================================');
            
            // check if name exist
            if(this.nameExist(data.function_name, data.function_id) ){
                this.props.notif("error",`Cette fonction existe déjà`)
                return
            }

            if(this.props.update){
                await this.props.updateFunction(data)
            } else {
                await this.props.newFunction(data)  
            }

            if(this.props.STATE.functions.error){
                console.log('====================================');
                console.log("ERROR", this.props.STATE.functions );
                console.log('====================================');
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.functions.error}`)
            } else {
                !this.props.update && this.props.notif("success","La fonction a été créée avec succès")
                this.props.update && this.props.notif("success","La fonction a été modifiée avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        return (
            <Dialog
                close={this.props.handleClose}
                // fullScreen
                title={`${this.props.update ? "Modifier la " : "Créer une"} Fonction`}
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.functions.fetching}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
            >
                <InputText
                    required
                    name="function_name" 
                    id="function_name" 
                    value={this.state.function_name} 
                    label="Nom" 
                    placeholder="Nom de la fonction" 
                    error={this.state.errors.function_name} 
                    onChange={this.handleChange}
                />
                    
            </Dialog>

        );
    }
}

export default FunctionForm;